import { CustomFonts } from 'app/components/custom-fonts';
import React, { Fragment } from 'react';
import { ErrorModal } from 'app/components/error-modal';
import { useErrors } from 'app/shared/contexts/errors';
import { ErrorPage } from 'app/pages/error';
import { useApi } from 'app/shared/contexts/api';

interface AppContentWrapperProps {
  children: React.ReactNode;
}

export const AppContentWrapper = ({ children }: AppContentWrapperProps): JSX.Element => {
  const { genericErrors } = useErrors();
  const { apiUrl } = useApi();

  // No loading spinner — MBO widgets render their own loading state. We only hard-stop
  // with the error page when critical data is missing (no API URL) or a critical fetch
  // failed (the widgets query). theme/user/building are non-blocking and never gate render.
  if (genericErrors.length > 0 || !apiUrl) {
    return <ErrorPage />;
  }

  return (
    <Fragment>
      <CustomFonts />
      <div className="max-h-screen bg-background text-foreground">
        {children}
        <ErrorModal />
      </div>
    </Fragment>
  );
};
